import styled from 'styled-components';
import { StyledButton as Button } from '../../CommonComponents/Button';

export const Wrapper = styled.div`
  padding: 70px;
`;

export const Title = styled.span`
  font-size: 24px;
  color: #444444;
  display: block;
  margin-bottom: 15px;
`;

export const ListItem = styled(Button.Link)`
  padding: 15px 0;
  display: block;
  width: 100%;
  text-align: left;

  & + & {
    border-top: 1px solid rgba(151, 151, 151, 0.33);
  }
`;

export const BackButton = styled(Button.Link).attrs({
  prependIcon: 'fa fa-caret-left',
})`
  position: absolute;
  top: 30px;
  left: 30px;
`;
